(function () {
    'use strict';

    setTimeout(function () {
        $('[data-form-target]').on('click', function (e) {
            var $element = $(this);
            var $target = $element.parent().find($element.data('form-target'));

            // Silently exit
            if ($target.length === 0) return;

            $target.submit();
        });
    }, 1000);

    if ($('#cancel-refund-booking-form').length || $('#charge-status-booking-form').length) {
        const cancelConfirmationModal = function (e) {
            if ($('#amount').val() == 0) {
                e.preventDefault();
                console.log(e);

                swal({
                    title: `Cancel without ${$('#isPOA').val() == 'true' ? 'charging' : 'refunding'}?`,
                    text: `This will cancel the booking without ${$('#isPOA').val() == 'true' ? 'charging' : 'refunding'} - do you want to proceed?`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes, cancel it!',
                    cancelButtonText: 'No',
                }, function (isConfirmed) {
                    if (isConfirmed) {
                        $('#cancel-refund-booking-form').trigger('submit');
                        $('#charge-status-booking-form').append(`<input type="hidden" name="update-status" value="${e.target.value}" /> `);
                        $('#charge-status-booking-form').trigger('submit');
                    }
                });
            }
        };
        $('#cancel-refund-booking-button').on('click', cancelConfirmationModal);
        $('#reattempt-charge-status-booking-button').on('click', cancelConfirmationModal);
        $('#manually-collected-charge-status-booking-button').on('click', cancelConfirmationModal);
        $('#uncollected-charge-status-booking-button').on('click', cancelConfirmationModal);
    }

    // Global bookings search
    $(document).on('submit', '.global-booking-search-form', function (e) {
        e.preventDefault();

        let search = $(this).find('.global-booking-search-query').val();

        axios
            .get(`/api/global-booking-search?search=${search}`)
            .then((response) => {
                let webBookings = '';
                let wheelsBookings = '';
                let location = '';

                $(this).find('.global-booking-search-no-bookings-box').addClass('d-none');

                if (response.data.webBookings.length) {
                    response.data.webBookings.forEach(booking => {
                        location = window.location.origin + `/web/bookings/${booking.booking_reference}`;
                        // location = window.location.origin + `/web/bookings?search=${booking.booking_reference}`;

                        webBookings += `<a class="dropdown-item" href="${location}">${booking.booking_reference}</a>`;
                    });

                    $(this).find('.global-booking-search-web-bookings-box').removeClass('d-none');
                } else {
                    $(this).find('.global-booking-search-web-bookings-box').addClass('d-none');
                }

                if (response.data.wheelsBookings.length) {
                    response.data.wheelsBookings.forEach(booking => {
                        location = window.location.origin + `/wheels/bookings/${booking.booking_reference}`;
                        // location = window.location.origin + `/wheels/bookings?search=${booking.booking_reference}`;

                        wheelsBookings += `<a class="dropdown-item" href="${location}">${booking.booking_reference}</a>`;
                    });

                    $(this).find('.global-booking-search-wheels-bookings-box').removeClass('d-none');
                } else {
                    $(this).find('.global-booking-search-wheels-bookings-box').addClass('d-none');
                }

                if (response.data.webBookings.length && response.data.wheelsBookings.length) {
                    $(this).find('.global-booking-search-divider').removeClass('d-none');
                } else {
                    $(this).find('.global-booking-search-divider').addClass('d-none');
                }

                $(this).find('.global-booking-search-web-bookings-list').html(webBookings);
                $(this).find('.global-booking-search-wheels-bookings-list').html(wheelsBookings);
                $(this).find('.global-booking-search-dropdown').addClass('d-block');

                if (response.data.webBookings.length === 0 && response.data.wheelsBookings.length === 0) {
                    $(this).find('.global-booking-search-no-bookings-box').removeClass('d-none');

                    $(this).find('.global-booking-search-web-bookings-box').addClass('d-none');
                    $(this).find('.global-booking-search-wheels-bookings-box').addClass('d-none');
                    $(this).find('.global-booking-search-divider').addClass('d-none');

                    $(this).find('.global-booking-search-dropdown').addClass('d-block');
                }
            })
            .catch((error) => {
            });
    });
})();